var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-menu-box"},_vm._l((_vm.routeData),function(item){return _c('a',{key:item.id,staticClass:"item-menu",class:{ active: _vm.checkActive(item) },on:{"click":function($event){return _vm.onTab(item)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }